/**
 * URL builders for every page with a URL. Pages link with these plus
 * `AppLink` ("link to person X"); `AppLink` decides main view vs. panel (K4).
 */
export { projectPath as projectHref } from "./contexts/project";
export { personPath as personHref } from "./contexts/person";
export { companyPath as companyHref } from "./contexts/company";
export { projectGroupPath as projectGroupHref } from "./contexts/projectGroup";
export { equipmentPath as equipmentHref } from "./contexts/equipment";
export { vehiclePath as vehicleHref } from "./contexts/vehicle";
export { studioPath as studioHref } from "./contexts/studio";
export { studioConfigPath as studioConfigHref } from "./contexts/studioConfig";
export { docPath as docHref } from "./contexts/docs";

/** Panel-only task (C6). */
export const taskHref = (taskId: string) => `/tasks/${taskId}`;

export const quoteHref = (
  projectId: string,
  quoteId: string,
  versionId?: string | null,
) =>
  `/projects/${projectId}/finance/quotes/${quoteId}${
    versionId ? `/versions/${versionId}` : ""
  }`;

/** Invoices of a project live in its context; others under global Finance. */
export const invoiceHref = (projectId: string | null, invoiceId: string) =>
  projectId
    ? `/projects/${projectId}/finance/invoices/${invoiceId}`
    : `/finance/invoices/${invoiceId}`;

export const cameraPlanHref = (projectId: string, planId: string) =>
  `/projects/${projectId}/plan/camera-plans/${planId}`;

/**
 * A meeting note stays in the context of its project or group (D12); notes
 * without one have their own page.
 */
export function meetingNoteHref(note: {
  id: string;
  project_id?: string | null;
  project_group_id?: string | null;
}) {
  if (note.project_id) {
    return `/projects/${note.project_id}/notes/meeting-notes/${note.id}`;
  }
  if (note.project_group_id) {
    return `/projects/groups/${note.project_group_id}/meeting-notes/${note.id}`;
  }
  return `/meeting-notes/${note.id}`;
}
